module.exports = __webpack_public_path__ + "img/contrSlope-nav.79f062ae.svg";